<template>
  <ValidationProvider
    v-slot="{ errors }"
    class="hm-switch-group"
    :class="{
      'hm-switch-group--disabled': disabled,
    }"
  >
    <label
      class="hm-switch"
      :class="{
        'hm-switch--active': value,
      }"
      :for="`hm-switch-input-${uid}`"
    >
      <span class="hm-switch-button"></span>
    </label>
    <input
      type="checkbox"
      :disabled="disabled"
      :value="value"
      @click="toggle"
      class="hm-switch-checkbox"
      :id="`hm-switch-input-${uid}`"
    />
    <span :id="`error_${uid}`">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'HMSwitch',
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    uid() {
      return this._uid;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      const toggled = !this.value;
      this.$emit('input', toggled);
      this.$emit('change', toggled);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
$height: 22px;
$padding: 2px;

.hm-switch-group {
  display: inline-block;
  position: relative;
  padding: 0.5rem 0;
  &--disabled {
    opacity: 0.5;
    .hm-switch {
      cursor: default;
    }
  }
}

.hm-switch {
  display: flex;
  align-items: center;
  margin: 0;

  cursor: pointer;
  user-select: none;

  width: 44px;
  border-radius: 22px;

  background-color: $medium-gray;

  &--active {
    background-color: var(--brand-color, $coral);
    .hm-switch-button {
      transform: translateX(18px);
    }
  }

  &--disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.hm-switch-button {
  display: flex;
  background-color: white;
  height: $height;
  width: $height;
  margin: 2px;
  border-radius: 50%;
  transform: translateX(0px);
  transition: transform 0.2s;
}

.hm-switch-checkbox {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}
</style>
